import { api } from '../../src/config';
import { getOnlineNode } from './getNode';

export const get_csrf_token = () => {
  return api({
    method: 'get',
    url: '/session/token?_format=json',
  });
};

export const get_logout_token = () => {
  return api({
    method: 'get',
    url: '/session/token/logout?_format=json',
    headers: {
      'Cache-Control': 'no-cache',
    },
  });
};

export const auth_login = (username, password, csrf_token) => {
  return api({
    method: 'post',
    url: '/user/login?_format=json',
    headers: {
      'X-CSRF-Token': csrf_token,
    },
    data: { name: username, pass: password },
  });
};

export const auth_logout = async () => {
  // Drupal 11: /user/logout has two routes on the same path — the browser route
  // (GET, confirm form) and the REST route user.logout.http (POST, _format=json).
  // Both now require a valid _csrf_token, so a stale/empty token yields 403
  // "'csrf_token' URL query argument is invalid." We therefore fetch a FRESH
  // logout_token (the CSRF token seeded for user.logout.http) and POST it
  // immediately within the same session — no React state, no stale closures.
  // Returns 204 on success.
  const { data } = await get_logout_token();
  return api({
    method: 'post',
    url: `/user/logout?_format=json&token=${data.logout_token}`,
    headers: {
      'Cache-Control': 'no-cache',
    },
  });
};

/**
 * Whether the browser still has a live Drupal session.
 *
 * Status codes cannot answer this. Anonymous requests are not uniformly 403 -
 * api/config, session/token and api/user_presentations all answer 200 - and a
 * 403 can equally mean a signed-in user hit something they lack access to, so
 * treating it as session loss would sign real users out mid-task.
 *
 * Drupal's login_status route reports it directly: always 200, body `1` when
 * authenticated and `0` when anonymous. It does not depend on route
 * permissions, so it stays correct no matter which endpoints are open to
 * anonymous users.
 *
 * @returns {Promise<boolean>} true if a session is still active.
 */
export const isSessionAlive = async () => {
  try {
    const response = await getOnlineNode("user/login_status?_format=json");
    return Number(response?.data) === 1;
  } catch (error) {
    // A network or server failure says nothing about the session. Assume it is
    // intact rather than telling someone they have been logged out.
    return true;
  }
};
